function setCookie(name, value, options) {
  let cookieStr = `${name}=${value}`;
  if (options) {
    if (options.maxAge) {
      cookieStr += `; max-age=${options.maxAge}`;
    }
    document.cookie = cookieStr;
  }
}

function getCookie(name) {
  return document.cookie
      .split(/\s*;\s*/)
      .find(cookie => cookie.startsWith(`${name}=`))
      ?.split('=')[1];
}

export {
  getCookie,
  setCookie
}